export default "https://cdn-static.gokick.com/assets/f9e57853bbf9ca449046a7aa5fdd940e337957cb/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";